import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@mui/material";
import { getNewsletterHistoryStatusMeta } from "./newsletterHistoryStatusUtils";

const NewsletterHistoryStatusChip = ({ status, size = "small" }) => {
  const meta = getNewsletterHistoryStatusMeta(status);
  return (
    <Chip
      label={meta.label}
      size={size}
      sx={{
        bgcolor: meta.bg,
        color: meta.color,
        fontWeight: 600,
        borderRadius: 1,
      }}
    />
  );
};

NewsletterHistoryStatusChip.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
};

export default NewsletterHistoryStatusChip;
